<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="error"
          icon
          v-bind="attrs"
          v-on="on">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </template>
      <alert-remove-card
        @confirm="submit()"
        @close="closeDialog()" />
    </v-dialog>
  </div>
</template>

<script>
import AlertRemoveCard from '@/components/Card/AlertRemoveCard.vue'
import { DELETE_STOCK } from '@/resources/graphql'

export default {
  name: 'WarehouseRemove',
  components: {
    AlertRemoveCard
  },
  props: {
    stockId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    },
    async submit () {
      await this.$apollo.mutate({
        mutation: DELETE_STOCK,
        variables: {
          input: {
            id: this.stockId
          }
        }
      })
      this.$emit('submit')
      this.closeDialog()
    }
  }
}
</script>
